import React from 'react';

export default function CheckedIconRadio() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="9" cy="9" r="5.5" stroke="#2D72D2" strokeWidth="7" />
        </svg>
    );
}